import React, { useState } from "react";
import { Button, Form, Input, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";

import { loginSchema } from "../validators/formSchema";
import { asyncLogin } from "../redux/slices/authSlice";

const Login = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => ({
    loading: state.auth.loading,
  }));

  const [passwordVisible, setPasswordVisible] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();

  const initialValue = {
    username: "",
    password: "",
  };

  return (
    <Formik
      initialValues={initialValue}
      validationSchema={loginSchema}
      onSubmit={(values) => {
        dispatch(asyncLogin(values)).then((res) => {
          if (res.payload.status === 201) {
            const token = res.payload.data?.token || "";
            sessionStorage.setItem("token", token);
            window.location.href = "/routes";
          } else {
            messageApi.open({
              type: "error",
              content: res.payload?.message || "Something want wrong",
            });
          }
        });
      }}
    >
      {({ handleChange, handleSubmit, values, errors, touched }) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            marginTop: "3rem",
          }}
        >
          {contextHolder}
          <Form
            name="normal_login"
            onFinish={handleSubmit}
            style={{
              backgroundColor: "#e6e8e6",
              padding: "3rem",
              borderRadius: "1rem",
              boxShadow:
                "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            }}
          >
            <div
              style={{
                marginBottom: "1rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <img
                src="/unnamed.png"
                alt="Logo"
                style={{ width: "7rem", height: "7rem" }}
              />
            </div>
            <div style={{ marginBottom: "1rem", width: "300px" }}>
              <label
                htmlFor="username"
                style={{ fontWeight: "bold" }}
                className="required"
              >
                Username
              </label>
              <Input
                name="username"
                prefix={<UserOutlined />}
                style={{ height: "2.5rem" }}
                placeholder="Username"
                value={values.username}
                onChange={handleChange}
              />
              {errors.username && touched.username && (
                <small id="email1-help" style={{ color: "red" }}>
                  {errors.username}
                </small>
              )}
            </div>

            <div style={{ marginBottom: "1rem", width: "300px" }}>
              <label
                htmlFor="password"
                style={{ fontWeight: "bold" }}
                className=" required"
              >
                Password
              </label>
              <Input.Password
                name="password"
                prefix={<LockOutlined />}
                placeholder="Input password"
                style={{ height: "2.5rem" }}
                value={values.password}
                onChange={handleChange}
                visibilityToggle={{
                  visible: passwordVisible,
                  onVisibleChange: setPasswordVisible,
                }}
              />
              {errors.password && touched.password && (
                <small id="password-help" style={{ color: "red" }}>
                  {errors.password}
                </small>
              )}
            </div>

            <div
              style={{
                marginTop: "2rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                style={{
                  padding: "0.5rem 3rem",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Log in
              </Button>
            </div>
          </Form>
        </div>
      )}
    </Formik>
  );
};

export default Login;
